<template>
    <div id="password-setup-page">

        <!-- White Box Section -->
        <section class="section-style margin-top-110">
            <div class="container padding-right-left-0">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8">
                        <div class="box-form bg-white box-shadow rounded">
                            <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Set a Password</h1>
                            <reset-password-form
                                    :form="form"
                                    :loading="loading"
                                    :submit-button-text="'Set your Password'"
                                    @submit="setPassword"></reset-password-form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import ResetPasswordForm from "../components/forms/ResetPasswordForm";

    export default {
        components: { ResetPasswordForm },

        data: function () {
            return {
                loading: false,
                form: {
                    username: '',
                    token: '',
                    password: '',
                    password_confirmation: ''
                }
            };
        },

        methods: {
            async setPassword(form) {

                this.loading = true;

                const response = await this.$httpClient.request('post', 'api/actions/setup-password', form, true);

                if (response.status === 'OK')
                    setTimeout(() => {
                        location.href = 'login';
                    }, 4000);
                else
                    this.loading = false;
            }
        },

        mounted() {
            const { username, token } = this.$route.query;

            if (!username || !token)
                this.$router.push("/");

            this.form.username = username;
            this.form.token = token;
        }
    }

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>